import { createStyles, makeStyles } from '@hawkins/styles';
export var paperStyles = function (theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name to apply to the root of the component */
        root: {
            color: hawkins.textColor.textColorRegular,
            backgroundColor: hawkins.elevation.backgroundColor0,
            padding: hawkinsVariables.spacings.space4,
            borderStyle: 'solid',
            borderWidth: hawkins.elevation.borderWidthFlat,
            borderColor: hawkins.elevation.borderColorFlat,
        },
        /** Class name to apply to the component when it is square */
        square: {
            borderRadius: 0,
        },
        /** Class name to apply to the component when it is rounded */
        rounded: {
            borderRadius: hawkinsVariables.borderRadius.borderRadius0,
        },
        /** Class name to apply when the elevation is 0 */
        elevation0: {},
        /** Class name to apply when the elevation is 1 */
        elevation1: {
            backgroundColor: hawkins.elevation.backgroundColor1,
            boxShadow: hawkins.elevation.boxShadow1,
            borderWidth: hawkins.elevation.borderWidthElevated,
            borderColor: hawkins.elevation.borderColorElevated,
        },
        /** Class name to apply when the elevation is 2 */
        elevation2: {
            backgroundColor: hawkins.elevation.backgroundColor2,
            boxShadow: hawkins.elevation.boxShadow2,
            borderWidth: hawkins.elevation.borderWidthElevated,
            borderColor: hawkins.elevation.borderColorElevated,
        },
    });
};
export var usePaperStyles = makeStyles(paperStyles, { name: 'Hawkins-Paper' });
